import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useSiteColors } from './hooks/useSiteColors';
import { useSiteLogo } from './hooks/useSiteLogo';
import { useEffect } from 'react';
import { supabase } from './lib/supabase';
import { ScrollToTop } from './components/ScrollToTop';

function App() {
  const { favicon } = useSiteLogo('frontend');

  // تحديث أيقونة الموقع عند تحميل التطبيق
  useEffect(() => {
    if (favicon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = favicon;
    }
  }, [favicon]);

  // تحديث عنوان الموقع عند تغيير اللغة
  useEffect(() => {
    const updateTitle = async () => {
      try {
        const { data } = await supabase
          .from('site_settings')
          .select('*')
          .eq('setting_key', 'site_info')
          .maybeSingle();

        if (data?.setting_value) {
          const lang = i18n.language === 'ar' ? 'ar' : 'en';
          const siteName = lang === 'ar' 
            ? data.setting_value.site_name_ar 
            : data.setting_value.site_name_en;
          
          if (siteName) {
            document.title = siteName;
          }
        }
      } catch (error) {
        console.error('Error updating title:', error);
      }
    };

    updateTitle();

    // الاستماع لتغيير اللغة
    const handleLanguageChange = () => {
      updateTitle();
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  useSiteColors();

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
